import * as React from 'react'
import Layout from '../components/layout'
import ProductList from '../components/product-list'

export default function Shop() {
  return (
    <Layout>
      <ProductList />
    </Layout>
  )
}
